import Model from '@/store/model';
import AbTestOnboardingLessonOrIslandInfo from './ab_test_onboarding_lesson_or_island_info';
import LessonTimerStatistics from './LessonTimerStatistics';

class AbInfo extends Model {
  map(json) {
    super.map(json);

    if (json && json.ab_test_onboarding_lesson_or_island_info != undefined && json.ab_test_onboarding_lesson_or_island_info !== null) {
      this.abTestOnboardingLessonOrIslandInfo = new AbTestOnboardingLessonOrIslandInfo();
      this.abTestOnboardingLessonOrIslandInfo.map(json.ab_test_onboarding_lesson_or_island_info);
    }

    if (json && json.lesson_timer_statistics != undefined && json.lesson_timer_statistics !== null) {
      this.lessonTimerStatistics = new LessonTimerStatistics();
      this.lessonTimerStatistics.map(json.lesson_timer_statistics);
    }
  }
}
export default AbInfo;
